var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "kamjyń",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "wyglancōwany granit",
  "block.minecraft.diorite": "dyjoryt",
  "block.minecraft.polished_diorite": "wyglancōwany dyjoryt",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "wyglancōwany andezit",
  "block.minecraft.grass_block": "blok trŏwy",
  "block.minecraft.dirt": "źymja",
  "block.minecraft.coarse_dirt": "twardŏ źymja",
  "block.minecraft.podzol": "bjołlica",
  "block.minecraft.crimson_nylium": "szkarłŏtne podglybie",
  "block.minecraft.warped_nylium": "szage podglybie",
  "block.minecraft.cobblestone": "kostka",
  "block.minecraft.oak_planks": "dymbowe belki",
  "block.minecraft.spruce_planks": "smrekowe belki",
  "block.minecraft.birch_planks": "brzeźne belki",
  "block.minecraft.jungle_planks": "dżunglowe belki",
  "block.minecraft.acacia_planks": "agacowe belki",
  "block.minecraft.dark_oak_planks": "ćmawodymbowe belki",
  "block.minecraft.crimson_planks": "szkarłŏtne belki",
  "block.minecraft.warped_planks": "szage belki",
  "block.minecraft.oak_sapling": "dymbowŏ flanca",
  "block.minecraft.spruce_sapling": "smrekowŏ flanca",
  "block.minecraft.birch_sapling": "brzeźnŏ flanca",
  "block.minecraft.jungle_sapling": "dżunglowŏ flanca",
  "block.minecraft.acacia_sapling": "agacowŏ flanca",
  "block.minecraft.dark_oak_sapling": "ćmawodymbowŏ flanca",
  "block.minecraft.bedrock": "zol",
  "block.minecraft.sand": "pjosek",
  "block.minecraft.red_sand": "czyrwōny pjosek",
  "block.minecraft.gravel": "kis",
  "block.minecraft.gold_ore": "ruda zôta",
  "block.minecraft.iron_ore": "ruda żylazŏ",
  "block.minecraft.coal_ore": "ruda wōngla",
  "block.minecraft.nether_gold_ore": "netherowŏ ruda zôta",
  "block.minecraft.oak_log": "dymbowy pniŏk",
  "block.minecraft.spruce_log": "smrekowy pniŏk",
  "block.minecraft.birch_log": "brzeźny pniŏk",
  "block.minecraft.jungle_log": "dżunglowy pniŏk",
  "block.minecraft.acacia_log": "agacowy pniŏk",
  "block.minecraft.dark_oak_log": "ćmawodymbowy pniŏk",
  "block.minecraft.crimson_stem": "szkarłŏtny strzōn",
  "block.minecraft.warped_stem": "szagi strzōn",
  "block.minecraft.stripped_oak_log": "ôłōbowany dymbowy pniok",
  "block.minecraft.stripped_spruce_log": "ôłōbowany smrekowy pniok",
  "block.minecraft.stripped_birch_log": "ôłōbowany brzeźny pniok",
  "block.minecraft.stripped_jungle_log": "ôłōbowany dżunglowy pniok",
  "block.minecraft.stripped_acacia_log": "ôłōbowany agacowy pniok",
  "block.minecraft.stripped_dark_oak_log": "ôłōbowany ćmawodymbowy pniŏk",
  "block.minecraft.stripped_crimson_stem": "ôłōbowany szkarłŏtny strzōn",
  "block.minecraft.stripped_warped_stem": "ôłōbowany szagi strzōn",
  "block.minecraft.stripped_oak_wood": "ôłōbowane dymbowe drzewo",
  "block.minecraft.stripped_spruce_wood": "ôłōbowane smrekowe drzewo",
  "block.minecraft.stripped_birch_wood": "ôłōbowany brzeźny pniok",
  "block.minecraft.stripped_jungle_wood": "ôłōbowane dżunglowe drzewo",
  "block.minecraft.stripped_acacia_wood": "ôłōbowane agacowe drzewo",
  "block.minecraft.stripped_dark_oak_wood": "ôłōbowane ćmawodymbowe drzewo",
  "block.minecraft.stripped_crimson_hyphae": "ôciŏsanŏ szkarłŏtnŏ strzympka",
  "block.minecraft.stripped_warped_hyphae": "ôciŏsanŏ szagŏ strzympka",
  "block.minecraft.oak_wood": "dymbowe drzewo",
  "block.minecraft.spruce_wood": "smrekowe drzewo",
  "block.minecraft.birch_wood": "brzezina",
  "block.minecraft.jungle_wood": "dżunglowe drzewo",
  "block.minecraft.acacia_wood": "agacowe drzewo",
  "block.minecraft.dark_oak_wood": "ćmawodymbowe drzewo",
  "block.minecraft.crimson_hyphae": "szkarłŏtnŏ strzympka",
  "block.minecraft.warped_hyphae": "szagŏ strzympka",
  "block.minecraft.oak_leaves": "dymbowe liście",
  "block.minecraft.spruce_leaves": "smrekowe liście",
  "block.minecraft.birch_leaves": "brzeźne liście",
  "block.minecraft.jungle_leaves": "dżunglowe liście",
  "block.minecraft.acacia_leaves": "agacowe liście",
  "block.minecraft.dark_oak_leaves": "ćmawodymbowe liście",
  "block.minecraft.sponge": "gōmbka",
  "block.minecraft.wet_sponge": "mokrŏ gōmbka",
  "block.minecraft.glass": "szkło",
  "block.minecraft.lapis_ore": "ruda lazuritu",
  "block.minecraft.lapis_block": "blok lazuritu",
  "block.minecraft.dispenser": "strzylŏcz",
  "block.minecraft.sandstone": "pjoskowjec",
  "block.minecraft.chiseled_sandstone": "ôciosany pjoskowjec",
  "block.minecraft.cut_sandstone": "pokroty pjoskowjec",
  "block.minecraft.note_block": "klangblok",
  "block.minecraft.powered_rail": "napyndzane glajzy",
  "block.minecraft.detector_rail": "glajzy ze synsorym",
  "block.minecraft.sticky_piston": "lepkawy pistōn",
  "block.minecraft.cobweb": "kawalera",
  "block.minecraft.grass": "trŏwa",
  "block.minecraft.fern": "paprotka",
  "block.minecraft.dead_bush": "uschnyty krzok",
  "block.minecraft.seagrass": "morskŏ trŏwa",
  "block.minecraft.sea_pickle": "ôgniczka",
  "block.minecraft.piston": "pistōn",
  "block.minecraft.white_wool": "bjołŏ wołna",
  "block.minecraft.orange_wool": "oranżowŏ wołna",
  "block.minecraft.magenta_wool": "karminowŏ wołna",
  "block.minecraft.light_blue_wool": "jasnomodrŏ wołna",
  "block.minecraft.yellow_wool": "żołtŏ wołna",
  "block.minecraft.lime_wool": "limōnkowŏ wołna",
  "block.minecraft.pink_wool": "rōżŏwŏ wołna",
  "block.minecraft.gray_wool": "szadŏ wołna",
  "block.minecraft.light_gray_wool": "jasnoszadŏ wołna",
  "block.minecraft.cyan_wool": "azurowŏ wołna",
  "block.minecraft.purple_wool": "porpōrowŏ wołna",
  "block.minecraft.blue_wool": "modrŏ wołna",
  "block.minecraft.brown_wool": "brunatnŏ wołna",
  "block.minecraft.green_wool": "źielōnŏ wołna",
  "block.minecraft.red_wool": "czerwōnŏ wołna",
  "block.minecraft.black_wool": "czornŏ wołna",
  "block.minecraft.dandelion": "mlycz",
  "block.minecraft.poppy": "mak",
  "block.minecraft.blue_orchid": "modry storczyk",
  "block.minecraft.allium": "knobloch",
  "block.minecraft.azure_bluet": "modrŏ houstonia",
  "block.minecraft.red_tulip": "czerwōnŏ tulpa",
  "block.minecraft.orange_tulip": "oranżowŏ tulpa",
  "block.minecraft.white_tulip": "bjołŏ tulpa",
  "block.minecraft.pink_tulip": "rōżowŏ tulpa",
  "block.minecraft.oxeye_daisy": "złociyń",
  "block.minecraft.cornflower": "faber",
  "block.minecraft.lily_of_the_valley": "majglokla",
  "block.minecraft.wither_rose": "witherrōłza",
  "block.minecraft.brown_mushroom": "prawok",
  "block.minecraft.red_mushroom": "sromotniŏk",
  "block.minecraft.crimson_fungus": "szkarłŏtny grzib",
  "block.minecraft.warped_fungus": "szagi grzib",
  "block.minecraft.crimson_roots": "szkarłŏtne korcze",
  "block.minecraft.warped_roots": "szage korcze",
  "block.minecraft.nether_sprouts": "netherowe flance",
  "block.minecraft.weeping_vines": "płaczkowe pnōncze",
  "block.minecraft.twisting_vines": "skryncōne pnōncza",
  "block.minecraft.sugar_cane": "trzcina cukrowŏ",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "blok zôta",
  "block.minecraft.iron_block": "blok żylaza",
  "block.minecraft.oak_slab": "dymbowŏ kachla",
  "block.minecraft.spruce_slab": "smrekowŏ kachla",
  "block.minecraft.birch_slab": "brzeźnŏ kachla",
  "block.minecraft.jungle_slab": "dżunglowŏ kachla",
  "block.minecraft.acacia_slab": "agacowŏ kachla",
  "block.minecraft.dark_oak_slab": "ćmawodymbowŏ kachla",
  "block.minecraft.crimson_slab": "szkarłŏtnŏ kachla",
  "block.minecraft.warped_slab": "szagŏ kachla",
  "block.minecraft.stone_slab": "kamjynnŏ kachla",
  "block.minecraft.smooth_stone_slab": "kachla ze śliskiygŏ kamjyniŏ",
  "block.minecraft.sandstone_slab": "pjoskowcowŏ kachla",
  "block.minecraft.cut_sandstone_slab": "kachla ze pokrŏtygŏ pjoskŏwca",
  "block.minecraft.petrified_oak_slab": "skamjyńołŏ dymbowŏ kachla",
  "block.minecraft.cobblestone_slab": "kostkowŏ kalcha",
  "block.minecraft.brick_slab": "cyglōwkowŏ kachla",
  "block.minecraft.stone_brick_slab": "kachla ze kamjynnych cygłōwek",
  "block.minecraft.nether_brick_slab": "kachla ze netherowej cygłōwki",
  "block.minecraft.quartz_slab": "kworcowŏ kachla",
  "block.minecraft.red_sandstone_slab": "kachla ze czerwonygŏ pjoskowca",
  "block.minecraft.cut_red_sandstone_slab": "kachla ze czerwōnygŏ pokrŏtygŏ pjoskŏwca",
  "block.minecraft.purpur_slab": "purpurowŏ kachla",
  "block.minecraft.prismarine_slab": "prizmarinowŏ kachla",
  "block.minecraft.prismarine_brick_slab": "kachla ze prizmarinowych cygłōwek",
  "block.minecraft.dark_prismarine_slab": "ćmawŏ prizmarinowŏ kachla",
  "block.minecraft.smooth_quartz": "blok śliskiygŏ kwŏrcu",
  "block.minecraft.smooth_red_sandstone": "śliski czyrwōny pjoskowjec",
  "block.minecraft.smooth_sandstone": "śliski pjoskowjec",
  "block.minecraft.smooth_stone": "śliski kamjyń",
  "block.minecraft.bricks": "cegłōwki",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "ksiōnżnicŏ",
  "block.minecraft.mossy_cobblestone": "zamszōnŏ kostka",
  "block.minecraft.obsidian": "ôbsydjōn",
  "block.minecraft.torch": "fakla",
  "block.minecraft.end_rod": "filorek endu",
  "block.minecraft.chorus_plant": "flanca refrynki",
  "block.minecraft.chorus_flower": "kwjot refrynki",
  "block.minecraft.purpur_block": "blok purpury",
  "block.minecraft.purpur_pillar": "purpurowy filor",
  "block.minecraft.purpur_stairs": "purpurowe schodki",
  "block.minecraft.spawner": "złōnacznik",
  "block.minecraft.oak_stairs": "dymbowe schodki",
  "block.minecraft.chest": "kastla",
  "block.minecraft.diamond_ore": "ruda dyjomyntu",
  "block.minecraft.diamond_block": "blok dyjomyntu",
  "block.minecraft.crafting_table": "falbanek",
  "block.minecraft.farmland": "źymja uprownŏ",
  "block.minecraft.furnace": "żeleźniŏk",
  "block.minecraft.ladder": "rzyps",
  "block.minecraft.rail": "glajzy",
  "block.minecraft.cobblestone_stairs": "kostkowe schodki",
  "block.minecraft.lever": "wajcha",
  "block.minecraft.stone_pressure_plate": "kamjynnŏ klikwoga",
  "block.minecraft.oak_pressure_plate": "dymbowŏ klikwoga",
  "block.minecraft.spruce_pressure_plate": "smrekowŏ klikwoga",
  "block.minecraft.birch_pressure_plate": "brzeźnŏ klikwoga",
  "block.minecraft.jungle_pressure_plate": "dżunglowŏ klikwoga",
  "block.minecraft.acacia_pressure_plate": "agacowŏ klikwoga",
  "block.minecraft.dark_oak_pressure_plate": "ćmawodymbowŏ klikwoga",
  "block.minecraft.crimson_pressure_plate": "szkarłŏtnŏ klikwoga",
  "block.minecraft.warped_pressure_plate": "szagŏ klikwoga",
  "block.minecraft.polished_blackstone_pressure_plate": "wyglancōwanŏ czorniŏkowŏ klikwoga",
  "block.minecraft.redstone_ore": "ruda rudziŏka",
  "block.minecraft.redstone_torch": "rudziŏkowŏ fakla",
  "block.minecraft.snow": "śniyg",
  "block.minecraft.ice": "lōd",
  "block.minecraft.snow_block": "blok śniygu",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "bōnc",
  "block.minecraft.jukebox": "muziczny szrank",
  "block.minecraft.oak_fence": "dymbowy płot",
  "block.minecraft.spruce_fence": "smrekowy płot",
  "block.minecraft.birch_fence": "brzeźny płot",
  "block.minecraft.jungle_fence": "dżunglowy płot",
  "block.minecraft.acacia_fence": "agacowy płot",
  "block.minecraft.dark_oak_fence": "ćmawodymbowy płot",
  "block.minecraft.crimson_fence": "szkarłŏtny płot",
  "block.minecraft.warped_fence": "szagi płot",
  "block.minecraft.pumpkin": "bania",
  "block.minecraft.carved_pumpkin": "wystruganŏ bania",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "pjosek dusz",
  "block.minecraft.soul_soil": "zol dusz",
  "block.minecraft.basalt": "bazŏlt",
  "block.minecraft.polished_basalt": "wyglancōwany bazŏlt",
  "block.minecraft.soul_torch": "fakla dusz",
  "block.minecraft.glowstone": "blyndŏk",
  "block.minecraft.jack_o_lantern": "śwjycōncŏ bania",
  "block.minecraft.oak_trapdoor": "dymbowŏ szłapa",
  "block.minecraft.spruce_trapdoor": "smrekowŏ szłapa",
  "block.minecraft.birch_trapdoor": "brzeźnŏ szłapa",
  "block.minecraft.jungle_trapdoor": "dżunglowŏ szłapa",
  "block.minecraft.acacia_trapdoor": "agacowŏ szłapa",
  "block.minecraft.dark_oak_trapdoor": "ćmawodymbowŏ szłapa",
  "block.minecraft.crimson_trapdoor": "szkarłŏtnŏ szłapa",
  "block.minecraft.warped_trapdoor": "szagŏ szłapa",
  "block.minecraft.infested_stone": "chrobaczywy kamjyń",
  "block.minecraft.infested_cobblestone": "chrobaczywŏ kostka",
  "block.minecraft.infested_stone_bricks": "chrobaczywe kamjynne cygłōwki",
  "block.minecraft.infested_mossy_stone_bricks": "chrobaczywe zamszōne kamjynne cygłōwki",
  "block.minecraft.infested_cracked_stone_bricks": "chrobaczywe pynknyte kamjynne cygłōwki",
  "block.minecraft.infested_chiseled_stone_bricks": "chrobaczywe wyrezane kamjynne cygłōwki",
  "block.minecraft.stone_bricks": "kamjynne cygłōwki",
  "block.minecraft.mossy_stone_bricks": "zamszōne kamjynne cygłōwki",
  "block.minecraft.cracked_stone_bricks": "pynknyte kamjynne cygłōwki",
  "block.minecraft.chiseled_stone_bricks": "ôciosane kamjynne cygłōwki",
  "block.minecraft.brown_mushroom_block": "blok prawoka",
  "block.minecraft.red_mushroom_block": "blok sromotniŏka",
  "block.minecraft.mushroom_stem": "sztyngel grziba",
  "block.minecraft.iron_bars": "żyloznŏ gitra",
  "block.minecraft.chain": "ketowy",
  "block.minecraft.glass_pane": "szyba",
  "block.minecraft.melon": "arbuz",
  "block.minecraft.vine": "klimatisu",
  "block.minecraft.oak_fence_gate": "dymbowŏ bramka",
  "block.minecraft.spruce_fence_gate": "smrekowŏ bramka",
  "block.minecraft.birch_fence_gate": "brzeźnŏ bramka",
  "block.minecraft.jungle_fence_gate": "dżunglowŏ bramka",
  "block.minecraft.acacia_fence_gate": "agacowŏ bramka",
  "block.minecraft.dark_oak_fence_gate": "ćmawodymbowŏ bramka",
  "block.minecraft.crimson_fence_gate": "szkarłŏtnŏ bramka",
  "block.minecraft.warped_fence_gate": "szagŏ bramka",
  "block.minecraft.brick_stairs": "cygłōwkowe schodki",
  "block.minecraft.stone_brick_stairs": "schodki ze kamjynnych cegłōwek",
  "block.minecraft.mycelium": "grziybniŏ",
  "block.minecraft.lily_pad": "wodnŏ lilijŏ",
  "block.minecraft.nether_bricks": "netherowe cygłōwki",
  "block.minecraft.cracked_nether_bricks": "pynknyte netherowe cygłōwki",
  "block.minecraft.chiseled_nether_bricks": "ôciosane netherowe cygłōwki",
  "block.minecraft.nether_brick_fence": "płot ze netherowych cygłōwek",
  "block.minecraft.nether_brick_stairs": "schodki ze netherowych cygłōwek",
  "block.minecraft.enchanting_table": "stōł dŏ magōwaniŏ",
  "block.minecraft.end_portal_frame": "roma portolu endu",
  "block.minecraft.end_stone": "kamjyń endu",
  "block.minecraft.end_stone_bricks": "cygłōwka ze kamjyniŏ endu",
  "block.minecraft.dragon_egg": "jajco draka",
  "block.minecraft.redstone_lamp": "rudziŏkowŏ lampa",
  "block.minecraft.sandstone_stairs": "pjoskowcowe schodki",
  "block.minecraft.emerald_ore": "ruda szmarogdu",
  "block.minecraft.ender_chest": "kastla endu",
  "block.minecraft.tripwire_hook": "hok na szpagat",
  "block.minecraft.emerald_block": "blok szmarogdu",
  "block.minecraft.spruce_stairs": "smrekowe schodki",
  "block.minecraft.birch_stairs": "brzeźne schodki",
  "block.minecraft.jungle_stairs": "dżunglowe schodki",
  "block.minecraft.crimson_stairs": "szkarłŏtne schodki",
  "block.minecraft.warped_stairs": "szage schodki",
  "block.minecraft.command_block": "blok kōmynd",
  "block.minecraft.beacon": "blynda",
  "block.minecraft.cobblestone_wall": "kostkowy murek",
  "block.minecraft.mossy_cobblestone_wall": "zamszōny kostkowy murek",
  "block.minecraft.brick_wall": "cygłōwkŏwy gelynder",
  "block.minecraft.prismarine_wall": "prizmarinŏwy gelynder",
  "block.minecraft.red_sandstone_wall": "gelynder ze czyrwōnygŏ pjoskŏwca",
  "block.minecraft.mossy_stone_brick_wall": "gelynder ze zamszōnych kamjynnych cygłōwek",
  "block.minecraft.granite_wall": "granitŏwy gelynder",
  "block.minecraft.stone_brick_wall": "gelynder ze kamjynnych cygłōwek",
  "block.minecraft.nether_brick_wall": "gelynder ze netherowyj cygłōwki",
  "block.minecraft.andesite_wall": "andezitŏwy gelynder",
  "block.minecraft.red_nether_brick_wall": "gelynder ze czyrwōnyj netherowyj cygłōwki",
  "block.minecraft.sandstone_wall": "pjoskŏwcŏwy gelynder",
  "block.minecraft.end_stone_brick_wall": "cygłōwkŏwy gelynder ze endowygŏ kamjyniŏ",
  "block.minecraft.diorite_wall": "dyjorytŏwy gelynder",
  "block.minecraft.blackstone_wall": "czorniŏkowy gelynder",
  "block.minecraft.polished_blackstone_wall": "wyglancōwany czorniŏkowy gelynder",
  "block.minecraft.polished_blackstone_brick_wall": "wyglancōwany czorniŏkowy cygłōwkowy gelynder",
  "block.minecraft.stone_button": "kamjynny knefel",
  "block.minecraft.oak_button": "dymbowy knefel",
  "block.minecraft.spruce_button": "smrekowy knefel",
  "block.minecraft.birch_button": "brzeźny knefel",
  "block.minecraft.jungle_button": "dżunglowy knefel",
  "block.minecraft.acacia_button": "agacowy knefel",
  "block.minecraft.dark_oak_button": "ćmawodymbowy knefel",
  "block.minecraft.crimson_button": "szkarłŏtny knefel",
  "block.minecraft.warped_button": "szagi knefel",
  "block.minecraft.polished_blackstone_button": "wyglancōwany czorniŏkowy knefel",
  "block.minecraft.anvil": "ambos",
  "block.minecraft.chipped_anvil": "uszczyrbany ambos",
  "block.minecraft.damaged_anvil": "poprzniōny ambos",
  "block.minecraft.trapped_chest": "paść-kastla",
  "block.minecraft.light_weighted_pressure_plate": "lekŏ klikwoga",
  "block.minecraft.heavy_weighted_pressure_plate": "ciyńszkŏ klikwoga",
  "block.minecraft.daylight_detector": "synsōr jasnŏka",
  "block.minecraft.redstone_block": "blok rudziŏka",
  "block.minecraft.nether_quartz_ore": "ruda kworcu",
  "block.minecraft.hopper": "lyjok",
  "block.minecraft.chiseled_quartz_block": "ôciosany blok kworcu",
  "block.minecraft.quartz_block": "blok kworcu",
  "block.minecraft.quartz_bricks": "kwŏrcŏwe cygłōwki",
  "block.minecraft.quartz_pillar": "kworcowy filorek",
  "block.minecraft.quartz_stairs": "kworcowe schodki",
  "block.minecraft.activator_rail": "aktiwacyjne glajzy",
  "block.minecraft.dropper": "podŏwocz",
  "block.minecraft.white_terracotta": "bjołŏ kamiōnka",
  "block.minecraft.orange_terracotta": "oranżowŏ kamiōnka",
  "block.minecraft.magenta_terracotta": "karminowŏ kamiōnka",
  "block.minecraft.light_blue_terracotta": "jasnomodrŏ kamiōnka",
  "block.minecraft.yellow_terracotta": "żołtŏ kamiōnka",
  "block.minecraft.lime_terracotta": "limōnkowŏ kamiōnka",
  "block.minecraft.pink_terracotta": "rōżŏwŏ kamiōnka",
  "block.minecraft.gray_terracotta": "szadŏ kamiōnka",
  "block.minecraft.light_gray_terracotta": "jasnoszadŏ kamiōnka",
  "block.minecraft.cyan_terracotta": "azurowŏ kamiōnka",
  "block.minecraft.purple_terracotta": "lilowŏ kamiōnka",
  "block.minecraft.blue_terracotta": "modrŏ kamiōnka",
  "block.minecraft.brown_terracotta": "brunatnŏ kamiōnka",
  "block.minecraft.green_terracotta": "źielōnŏ kamiōnka",
  "block.minecraft.red_terracotta": "czerwōnŏ kamiōnka",
  "block.minecraft.black_terracotta": "czornŏ kamiōnka",
  "block.minecraft.barrier": "baryjera",
  "block.minecraft.iron_trapdoor": "żylaznŏ szłapa",
  "block.minecraft.hay_block": "bal siana",
  "block.minecraft.white_carpet": "bjoły tepich",
  "block.minecraft.orange_carpet": "oranżowy tepich",
  "block.minecraft.magenta_carpet": "karminowy tepich",
  "block.minecraft.light_blue_carpet": "jasnomodry tepich",
  "block.minecraft.yellow_carpet": "żołty tepich",
  "block.minecraft.lime_carpet": "limōnkowy tepich",
  "block.minecraft.pink_carpet": "rōżowy tepich",
  "block.minecraft.gray_carpet": "szady tepich",
  "block.minecraft.light_gray_carpet": "jasnoszady tepich",
  "block.minecraft.cyan_carpet": "azurowy tepich",
  "block.minecraft.purple_carpet": "lilowy tepich",
  "block.minecraft.blue_carpet": "modry tepich",
  "block.minecraft.brown_carpet": "brunatny tepich",
  "block.minecraft.green_carpet": "zielōny tepich",
  "block.minecraft.red_carpet": "czerwōny tepich",
  "block.minecraft.black_carpet": "czorny tepich",
  "block.minecraft.terracotta": "kamiōnka",
  "block.minecraft.coal_block": "blok wōngla",
  "block.minecraft.packed_ice": "zewarty lōd",
  "block.minecraft.acacia_stairs": "agacowe schodki",
  "block.minecraft.dark_oak_stairs": "ćmawodymbowe schodki",
  "block.minecraft.slime_block": "szlōmblok",
  "block.minecraft.grass_path": "trŏwjastŏ cesta",
  "block.minecraft.sunflower": "zonynbluma",
  "block.minecraft.lilac": "bez",
  "block.minecraft.rose_bush": "krzok rŏzy",
  "block.minecraft.peony": "piwowońka",
  "block.minecraft.tall_grass": "wysokŏ trŏwa",
  "block.minecraft.large_fern": "srogo paprotka",
  "block.minecraft.white_stained_glass": "bjołe szkło",
  "block.minecraft.orange_stained_glass": "oranżowe szkło",
  "block.minecraft.magenta_stained_glass": "karminowe szkło",
  "block.minecraft.light_blue_stained_glass": "jasnomodre szkło",
  "block.minecraft.yellow_stained_glass": "żołte szkło",
  "block.minecraft.lime_stained_glass": "limōnkowe szkło",
  "block.minecraft.pink_stained_glass": "rōżŏwe szkło",
  "block.minecraft.gray_stained_glass": "szade szkło",
  "block.minecraft.light_gray_stained_glass": "jasnoszade szkło",
  "block.minecraft.cyan_stained_glass": "azurowe szkło",
  "block.minecraft.purple_stained_glass": "lilowe szkło",
  "block.minecraft.blue_stained_glass": "modre szkło",
  "block.minecraft.brown_stained_glass": "brunatne szkło",
  "block.minecraft.green_stained_glass": "zielōne szkło",
  "block.minecraft.red_stained_glass": "czyrwōne szkło",
  "block.minecraft.black_stained_glass": "czorne szkło",
  "block.minecraft.white_stained_glass_pane": "bjołŏ szyba",
  "block.minecraft.orange_stained_glass_pane": "oranżowŏ szyba",
  "block.minecraft.magenta_stained_glass_pane": "karminowŏ szyba",
  "block.minecraft.light_blue_stained_glass_pane": "jasnomodrŏ szyba",
  "block.minecraft.yellow_stained_glass_pane": "żołtŏ szyba",
  "block.minecraft.lime_stained_glass_pane": "limōnkowŏ szyba",
  "block.minecraft.pink_stained_glass_pane": "rōżowŏ szyba",
  "block.minecraft.gray_stained_glass_pane": "szadŏ szyba",
  "block.minecraft.light_gray_stained_glass_pane": "jasnoszadŏ szyba",
  "block.minecraft.cyan_stained_glass_pane": "azurowŏ szyba",
  "block.minecraft.purple_stained_glass_pane": "lilowŏ szyba",
  "block.minecraft.blue_stained_glass_pane": "modrŏ szyba",
  "block.minecraft.brown_stained_glass_pane": "brunatnŏ szyba",
  "block.minecraft.green_stained_glass_pane": "zielōnŏ szyba",
  "block.minecraft.red_stained_glass_pane": "czerwonŏ szyba",
  "block.minecraft.black_stained_glass_pane": "czornŏ szyba",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "prizmarinŏwe cygłōwki",
  "block.minecraft.dark_prismarine": "ćmawy prizmarin",
  "block.minecraft.prismarine_stairs": "prizmarinowe schodki",
  "block.minecraft.prismarine_brick_stairs": "schodki ze prizmarinowych cygłōwek",
  "block.minecraft.dark_prismarine_stairs": "ćmawe prizmarinowe schodki",
  "block.minecraft.sea_lantern": "morskŏ latarniŏ",
  "block.minecraft.red_sandstone": "czyrwōny pjoskowjec",
  "block.minecraft.chiseled_red_sandstone": "ôciosany czyrwōny pjoskowjec",
  "block.minecraft.cut_red_sandstone": "pokroty czerwōny pjoskowjec",
  "block.minecraft.red_sandstone_stairs": "schodki ze czerwonygo pjoskowca",
  "block.minecraft.repeating_command_block": "tuplowaty blok kōmynd",
  "block.minecraft.chain_command_block": "ketowaty blok kōmynd",
  "block.minecraft.magma_block": "blok magmy",
  "block.minecraft.nether_wart_block": "blok netherowyj chrosty",
  "block.minecraft.warped_wart_block": "blok szagiyj chrosty",
  "block.minecraft.red_nether_bricks": "czerwōne netherowe cygłōwki",
  "block.minecraft.bone_block": "blok kostyry",
  "block.minecraft.structure_void": "prōżniŏ strukturalnŏ",
  "block.minecraft.observer": "detektōr",
  "block.minecraft.shulker_box": "shulkerowŏ kastla",
  "block.minecraft.white_shulker_box": "bjołŏ shulkerowŏ kastla",
  "block.minecraft.orange_shulker_box": "oranżowŏ shulkerowŏ kastla",
  "block.minecraft.magenta_shulker_box": "karminowŏ shulkerowŏ kastla",
  "block.minecraft.light_blue_shulker_box": "jasnomodrŏ shulkerowŏ kastla",
  "block.minecraft.yellow_shulker_box": "żołtŏ shulkerowŏ kastla",
  "block.minecraft.lime_shulker_box": "limōnkowŏ shulkerowŏ kastla",
  "block.minecraft.pink_shulker_box": "rōżŏwŏ shulkerowŏ kastla",
  "block.minecraft.gray_shulker_box": "szadŏ shulkerowŏ kastla",
  "block.minecraft.light_gray_shulker_box": "jasnoszadŏ shulkerowŏ kastla",
  "block.minecraft.cyan_shulker_box": "azurowŏ shulkerowŏ kastla",
  "block.minecraft.purple_shulker_box": "lilowŏ shulkerowŏ kastla",
  "block.minecraft.blue_shulker_box": "modrŏ shulkerowŏ kastla",
  "block.minecraft.brown_shulker_box": "brunatnŏ shulkerowŏ kastla",
  "block.minecraft.green_shulker_box": "źielōnŏ shulkerowŏ kastla",
  "block.minecraft.red_shulker_box": "czerwōnŏ shulkerowŏ kastla",
  "block.minecraft.black_shulker_box": "czornŏ shulkerowŏ kastla",
  "block.minecraft.white_glazed_terracotta": "bjołŏ glazōwanŏ kamiōnka",
  "block.minecraft.orange_glazed_terracotta": "oranżowŏ glazōwanŏ kamiōnka",
  "block.minecraft.magenta_glazed_terracotta": "karminowŏ glazōwanŏ kamiōnka",
  "block.minecraft.light_blue_glazed_terracotta": "jasnomodrŏ glazōwanŏ kamiōnka",
  "block.minecraft.yellow_glazed_terracotta": "żołtŏ glazōwanŏ kamiōnka",
  "block.minecraft.lime_glazed_terracotta": "limōnkowŏ glazōwanŏ kamiōnka",
  "block.minecraft.pink_glazed_terracotta": "rōżŏwŏ glazōwanŏ kamiōnka",
  "block.minecraft.gray_glazed_terracotta": "szadŏ glazōwanŏ kamiōnka",
  "block.minecraft.light_gray_glazed_terracotta": "jasnoszadŏ glazōwanŏ kamiōnka",
  "block.minecraft.cyan_glazed_terracotta": "azurowŏ glazōwanŏ kamiōnka",
  "block.minecraft.purple_glazed_terracotta": "lilowŏ glazōwanŏ kamiōnka",
  "block.minecraft.blue_glazed_terracotta": "modrŏ glazōwanŏ kamiōnka",
  "block.minecraft.brown_glazed_terracotta": "brunatnŏ glazōwanŏ kamiōnka",
  "block.minecraft.green_glazed_terracotta": "źielōnŏ glazōwanŏ kamiōnka",
  "block.minecraft.red_glazed_terracotta": "czerwōnŏ glazōwanŏ kamiōnka",
  "block.minecraft.black_glazed_terracotta": "czornŏ glazōwanŏ kamiōnka",
  "block.minecraft.white_concrete": "bjoły bytōn",
  "block.minecraft.orange_concrete": "oranżowy bytōn",
  "block.minecraft.magenta_concrete": "karminowy bytōn",
  "block.minecraft.light_blue_concrete": "jasnomodry bytōn",
  "block.minecraft.yellow_concrete": "żołty bytōn",
  "block.minecraft.lime_concrete": "limōnkowy bytōn",
  "block.minecraft.pink_concrete": "rōżŏwy bytōn",
  "block.minecraft.gray_concrete": "szady bytōn",
  "block.minecraft.light_gray_concrete": "jasnoszady bytōn",
  "block.minecraft.cyan_concrete": "azurowy bytōn",
  "block.minecraft.purple_concrete": "lilowy bytōn",
  "block.minecraft.blue_concrete": "modry bytōn",
  "block.minecraft.brown_concrete": "brunatny bytōn",
  "block.minecraft.green_concrete": "źielōny bytōn",
  "block.minecraft.red_concrete": "czerwōny bytōn",
  "block.minecraft.black_concrete": "czorny bytōn",
  "block.minecraft.white_concrete_powder": "bjoły cymynt",
  "block.minecraft.orange_concrete_powder": "oranżowy cymynt",
  "block.minecraft.magenta_concrete_powder": "karminowy cymynt",
  "block.minecraft.light_blue_concrete_powder": "jasnomodry cymynt",
  "block.minecraft.yellow_concrete_powder": "żołty cymynt",
  "block.minecraft.lime_concrete_powder": "limŏnkowy cymynt",
  "block.minecraft.pink_concrete_powder": "rōżŏwy cymynt",
  "block.minecraft.gray_concrete_powder": "szady cymynt",
  "block.minecraft.light_gray_concrete_powder": "jasnoszady cymynt",
  "block.minecraft.cyan_concrete_powder": "azurowy cymynt",
  "block.minecraft.purple_concrete_powder": "lilowy cymynt",
  "block.minecraft.blue_concrete_powder": "modry cymynt",
  "block.minecraft.brown_concrete_powder": "brunatny cymynt",
  "block.minecraft.green_concrete_powder": "źielōny cymynt",
  "block.minecraft.red_concrete_powder": "czerwōny cymynt",
  "block.minecraft.black_concrete_powder": "czorny cymynt",
  "block.minecraft.turtle_egg": "jajco żōłwia",
  "block.minecraft.dead_tube_coral_block": "blok pōmrzytygŏ kōrola rułowatygo",
  "block.minecraft.dead_brain_coral_block": "blok pōmrzytygŏ kōrola mōzgowygŏ",
  "block.minecraft.dead_bubble_coral_block": "blok pōmrzytygŏ kōrola bōmblōwatygŏ",
  "block.minecraft.dead_fire_coral_block": "blok pōmrzytygŏ kōrola ôgniŏwygŏ",
  "block.minecraft.dead_horn_coral_block": "blok pōmrzytygŏ kōrola rōgatygŏ",
  "block.minecraft.tube_coral_block": "blok kōrola rułowatygŏ",
  "block.minecraft.brain_coral_block": "blok kōrola mōzgowygŏ",
  "block.minecraft.bubble_coral_block": "blok kōrola bōmblōwatygŏ",
  "block.minecraft.fire_coral_block": "blok kōrola ôgniŏwygŏ",
  "block.minecraft.horn_coral_block": "blok kōrola rōgatygŏ",
  "block.minecraft.tube_coral": "kōrol rułowaty",
  "block.minecraft.brain_coral": "kōrol mōzgowy",
  "block.minecraft.bubble_coral": "kōrol bōmblowy",
  "block.minecraft.fire_coral": "kōrol ôgniŏwy",
  "block.minecraft.horn_coral": "kōrol rōgaty",
  "block.minecraft.dead_brain_coral": "pōmrzyty kōrol mōzgowy",
  "block.minecraft.dead_bubble_coral": "pōmrzyty kōrol bōmblōwaty",
  "block.minecraft.dead_fire_coral": "pōmrzyty kōrol ôgniŏwy",
  "block.minecraft.dead_horn_coral": "pōmrzyty kōrol rōgaty",
  "block.minecraft.dead_tube_coral": "pōmrzyty kōrol rułowaty",
  "block.minecraft.tube_coral_fan": "wachlŏrz kōrola rułowatygŏ",
  "block.minecraft.brain_coral_fan": "wachlŏrz kōrola mōzgowygŏ",
  "block.minecraft.bubble_coral_fan": "wachlŏrz kōrola bōmblōwatygŏ",
  "block.minecraft.fire_coral_fan": "wachlŏrz kōrola ôgniŏwygŏ",
  "block.minecraft.horn_coral_fan": "wachlŏrz kōrola rōgatygŏ",
  "block.minecraft.dead_tube_coral_fan": "pōmrzyty wachlŏrz kōrola rułowatygŏ",
  "block.minecraft.dead_brain_coral_fan": "pōmrzyty wachlŏrz kōrola mōzgowygŏ",
  "block.minecraft.dead_bubble_coral_fan": "pōmrzyty wachlŏrz kōrola bōmblōwatygŏ",
  "block.minecraft.dead_fire_coral_fan": "pōmrzyty wachlŏrz kōrola ôgniŏwygŏ",
  "block.minecraft.dead_horn_coral_fan": "pōmrzyty wachlŏrz kōrola rōgatygŏ",
  "block.minecraft.blue_ice": "modry lōd",
  "block.minecraft.conduit": "konduktor",
  "block.minecraft.polished_granite_stairs": "schodki ze wyglancōwanygŏ granitu",
  "block.minecraft.smooth_red_sandstone_stairs": "schodki ze śliskiygŏ czyrwōnygŏ pjoskŏwca",
  "block.minecraft.mossy_stone_brick_stairs": "schodki ze zamszōnych kamjynnych cygłōwek",
  "block.minecraft.polished_diorite_stairs": "schodki ze wyglancōwanygŏ dyjorytu",
  "block.minecraft.mossy_cobblestone_stairs": "schodki ze zamszōnyj kostki",
  "block.minecraft.end_stone_brick_stairs": "schodki ze kamjynnych endowych cygłōwek",
  "block.minecraft.stone_stairs": "kamjynne schodki",
  "block.minecraft.smooth_sandstone_stairs": "schodki ze śliskiygŏ pjoskŏwca",
  "block.minecraft.smooth_quartz_stairs": "schodki ze śliskiygŏ kworcu",
  "block.minecraft.granite_stairs": "granitowe schodki",
  "block.minecraft.andesite_stairs": "andezitŏwe schodki",
  "block.minecraft.red_nether_brick_stairs": "schodki ze czyrwōnyj netherowyj cygłōwki",
  "block.minecraft.polished_andesite_stairs": "schodki ze wyglancōwanygŏ andezitu",
  "block.minecraft.diorite_stairs": "schodki ze dyjorytu",
  "block.minecraft.polished_granite_slab": "kachla ze wyglancōwanygŏ granitu",
  "block.minecraft.smooth_red_sandstone_slab": "kachla ze śliskiygŏ czyrwōnygŏ pjoskŏwca",
  "block.minecraft.mossy_stone_brick_slab": "kachla ze zamszōnych kamjynnych cygłōwek",
  "block.minecraft.polished_diorite_slab": "kachla ze wyglancōwanygŏ dyjorytu",
  "block.minecraft.mossy_cobblestone_slab": "kachla ze zamszōnyj kostki",
  "block.minecraft.end_stone_brick_slab": "kachla ze kamjynnych endowych cygłōwek",
  "block.minecraft.smooth_sandstone_slab": "kachla ze śliskiygŏ pjoskŏwca",
  "block.minecraft.smooth_quartz_slab": "kachla ze śliskiygŏ kworcu",
  "block.minecraft.granite_slab": "granitowŏ kachla",
  "block.minecraft.andesite_slab": "andezitowŏ kachla",
  "block.minecraft.red_nether_brick_slab": "kachla ze czyrwōnyj netherowyj cygłōwki",
  "block.minecraft.polished_andesite_slab": "kachla ze wyglancōwanygŏ andezitu",
  "block.minecraft.diorite_slab": "dyjorytŏwŏ kachla",
  "block.minecraft.scaffolding": "rusztōnek",
  "block.minecraft.iron_door": "żylazne dźwiyrza",
  "block.minecraft.oak_door": "dymbowe dźwiyrza",
  "block.minecraft.spruce_door": "smrekowe dźwiyrza",
  "block.minecraft.birch_door": "brzeźne dźwiyrza",
  "block.minecraft.jungle_door": "dżunglowe dźwiyrza",
  "block.minecraft.acacia_door": "agacowe dźwiyrza",
  "block.minecraft.dark_oak_door": "ćmawodymbowe dźwiyrza",
  "block.minecraft.crimson_door": "szkarłŏtne dźwiyrza",
  "block.minecraft.warped_door": "szage dźwiyrza",
  "block.minecraft.repeater": "przekŏźnik",
  "block.minecraft.comparator": "kōmparatōr",
  "block.minecraft.structure_block": "blok struktur",
  "block.minecraft.jigsaw": "blok łōmigōwyk",
  "item.minecraft.turtle_helmet": "żōłwiŏ szupa□□kiej na gowie:□+2 zbrojŏ",
  "item.minecraft.scute": "ôsłōnka",
  "item.minecraft.iron_shovel": "żylŏznŏ szipa□□kiej we gōwnyj rynce:□+3.5 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.iron_pickaxe": "żylŏznŏ haka□□kiej we gōwnyj rynce:□+3 ôchybiyniŏ□-2.8 gibkość napŏdu",
  "item.minecraft.iron_axe": "żylŏznŏ cieślica□□kiej we gōwnyj rynce:□+8 ôchybiyniŏ□-3.1 gibkość napŏdu",
  "item.minecraft.flint_and_steel": "fojercok",
  "item.minecraft.apple": "płōnka",
  "item.minecraft.bow": "bōgyn",
  "item.minecraft.arrow": "strzała",
  "item.minecraft.coal": "wōngel",
  "item.minecraft.charcoal": "drzewny wōngel",
  "item.minecraft.diamond": "dyjomynt",
  "item.minecraft.iron_ingot": "szynka żylŏza",
  "item.minecraft.gold_ingot": "szynka zôta",
  "item.minecraft.netherite_ingot": "szynka netheritu",
  "item.minecraft.netherite_scrap": "netheritowy klamor",
  "item.minecraft.iron_sword": "żylŏzny mjycz□□kiej we gōwnyj rynce:□+5 ôchybiyniŏ□-2.4 gibkość napŏdu",
  "item.minecraft.wooden_sword": "drzewny mjycz□□kiej we gōwnyj rynce:□+3 ôchybiyniŏ□-2.4 gibkość napŏdu",
  "item.minecraft.wooden_shovel": "drzewnŏ szipa□□kiej we gōwnyj rynce:□+1.5 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.wooden_pickaxe": "drzewnŏ haka□□kiej we gōwnyj rynce:□+1 ôchybiyniŏ□-2.8 gibkość napŏdu",
  "item.minecraft.wooden_axe": "drzewnŏ cieślica□□kiej we gōwnyj rynce:□+6 ôchybiyniŏ□-3.2 gibkość napŏdu",
  "item.minecraft.stone_sword": "kamjynny mjycz□□kiej we gōwnyj rynce:□+4 ôchybiyniŏ□-2.4 gibkość napŏdu",
  "item.minecraft.stone_shovel": "kamjynnŏ szipa□□kiej we gōwnyj rynce:□+2.5 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.stone_pickaxe": "kamjynnŏ haka□□kiej we gōwnyj rynce:□+2 ôchybiyniŏ□-2.8 gibkość napŏdu",
  "item.minecraft.stone_axe": "kamjynnŏ cieślica□□kiej we gōwnyj rynce:□+8 ôchybiyniŏ□-3.2 gibkość napŏdu",
  "item.minecraft.diamond_sword": "dyjomyntowy mjycz□□kiej we gōwnyj rynce:□+6 ôchybiyniŏ□-2.4 gibkość napŏdu",
  "item.minecraft.diamond_shovel": "dyjomyntowŏ szipa□□kiej we gōwnyj rynce:□+4.5 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.diamond_pickaxe": "dyjomyntowŏ haka□□kiej we gōwnyj rynce:□+4 ôchybiyniŏ□-2.8 gibkość napŏdu",
  "item.minecraft.diamond_axe": "dyjomyntowŏ cieślica□□kiej we gōwnyj rynce:□+8 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.stick": "kijok",
  "item.minecraft.bowl": "waszpek",
  "item.minecraft.mushroom_stew": "zupa grziybowŏ",
  "item.minecraft.golden_sword": "zôty mjycz□□kiej we gōwnyj rynce:□+3 ôchybiyniŏ□-2.4 gibkość napŏdu",
  "item.minecraft.golden_shovel": "zôtŏ szipa□□kiej we gōwnyj rynce:□+1.5 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.golden_pickaxe": "zôtŏ haka□□kiej we gōwnyj rynce:□+1 ôchybiyniŏ□-2.8 gibkość napŏdu",
  "item.minecraft.golden_axe": "zôtŏ cieślica□□kiej we gōwnyj rynce:□+6 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.netherite_sword": "netheritowy mjycz□□kiej we gōwnyj rynce:□+7 ôchybiyniŏ□-2.4 gibkość napŏdu",
  "item.minecraft.netherite_shovel": "netheritowŏ szipa□□kiej we gōwnyj rynce:□+5.5 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.netherite_pickaxe": "netheritowŏ haka□□kiej we gōwnyj rynce:□+5 ôchybiyniŏ□-2.8 gibkość napŏdu",
  "item.minecraft.netherite_axe": "netheritowŏ cieślica□□kiej we gōwnyj rynce:□+9 ôchybiyniŏ□-3 gibkość napŏdu",
  "item.minecraft.string": "nitka",
  "item.minecraft.feather": "pjyrze",
  "item.minecraft.gunpowder": "proch",
  "item.minecraft.wooden_hoe": "drzewnŏ kōpaczka□□kiej we gōwnyj rynce:□-3 gibkość napŏdu",
  "item.minecraft.stone_hoe": "kamjynnŏ kōpaczka□□kiej we gōwnyj rynce:□-2 gibkość napŏdu",
  "item.minecraft.iron_hoe": "żyloznŏ kōpaczka□□kiej we gōwnyj rynce:□-1 gibkość napŏdu",
  "item.minecraft.diamond_hoe": "dyjomyntowŏ kōpaczka□□kiej we gōwnyj rynce:",
  "item.minecraft.golden_hoe": "zôtŏ kōpaczka□□kiej we gōwnyj rynce:□-3 gibkość napŏdu",
  "item.minecraft.netherite_hoe": "netheritowŏ kōpaczka□□kiej we gōwnyj rynce:",
  "item.minecraft.wheat_seeds": "ôsucie ôbiyli",
  "item.minecraft.wheat": "ôbiyli",
  "item.minecraft.bread": "chlyb",
  "item.minecraft.leather_helmet": "skōrzanŏ czopka□□kiej na gowie:□+1 zbrojŏ",
  "item.minecraft.leather_chestplate": "skōrzanŏ jakla□□kiej na ciele:□+3 zbrojŏ",
  "item.minecraft.leather_leggings": "skōrzane galoty□□kiej na szłapie:□+2 zbrojŏ",
  "item.minecraft.leather_boots": "skōrzane strzewiki□□kiej na szwaji:□+1 zbrojŏ",
  "item.minecraft.chainmail_helmet": "szupny hyłm□□kiej na gowie:□+2 zbrojŏ",
  "item.minecraft.chainmail_chestplate": "szupny kirys□□kiej na ciele:□+5 zbrojŏ",
  "item.minecraft.chainmail_leggings": "szupne galŏty□□kiej na szłapie:□+4 zbrojŏ",
  "item.minecraft.chainmail_boots": "szupne strzewiki□□kiej na szwaji:□+1 zbrojŏ",
  "item.minecraft.iron_helmet": "żylŏzny hyłm□□kiej na gowie:□+2 zbrojŏ",
  "item.minecraft.iron_chestplate": "żylŏzny kirys□□kiej na ciele:□+6 zbrojŏ",
  "item.minecraft.iron_leggings": "żylŏzne galoty□□kiej na szłapie:□+5 zbrojŏ",
  "item.minecraft.iron_boots": "żylŏzne strzewiki□□kiej na szwaji:□+2 zbrojŏ",
  "item.minecraft.diamond_helmet": "dyjomyntowy hyłm□□kiej na gowie:□+3 zbrojŏ□+2 strzimałŏść zbroji",
  "item.minecraft.diamond_chestplate": "dyjomyntŏwy kirys□□kiej na ciele:□+8 zbrojŏ□+2 strzimałŏść zbroji",
  "item.minecraft.diamond_leggings": "dyjomyntŏwe galoty□□kiej na szłapie:□+6 zbrojŏ□+2 strzimałŏść zbroji",
  "item.minecraft.diamond_boots": "dyjomyntŏwe bōty□□kiej na szwaji:□+3 zbrojŏ□+2 strzimałŏść zbroji",
  "item.minecraft.golden_helmet": "zôty hyłm□□kiej na gowie:□+2 zbrojŏ",
  "item.minecraft.golden_chestplate": "zôty kirys□□kiej na ciele:□+5 zbrojŏ",
  "item.minecraft.golden_leggings": "zôte galoty□□kiej na szłapie:□+3 zbrojŏ",
  "item.minecraft.golden_boots": "zôte bōty□□kiej na szwaji:□+1 zbrojŏ",
  "item.minecraft.netherite_helmet": "netheritowy hyłm□□kiej na gowie:□+3 zbrojŏ□+3 strzimałŏść zbroji□+1 ôbstōńy na ôdciep",
  "item.minecraft.netherite_chestplate": "netheritowy kirys□□kiej na ciele:□+8 zbrojŏ□+3 strzimałŏść zbroji□+1 ôbstōńy na ôdciep",
  "item.minecraft.netherite_leggings": "netheritowe galŏty□□kiej na szłapie:□+6 zbrojŏ□+3 strzimałŏść zbroji□+1 ôbstōńy na ôdciep",
  "item.minecraft.netherite_boots": "netheritowe bōty□□kiej na szwaji:□+3 zbrojŏ□+3 strzimałŏść zbroji□+1 ôbstōńy na ôdciep",
  "item.minecraft.flint": "krzemjyń",
  "item.minecraft.porkchop": "surowy sznycel",
  "item.minecraft.cooked_porkchop": "pieczōny sznycel",
  "item.minecraft.painting": "ôbrŏz",
  "item.minecraft.golden_apple": "zôtŏ płōnka",
  "item.minecraft.enchanted_golden_apple": "zamagōwanŏ zôtŏ płōnka",
  "block.minecraft.oak_sign": "dymbŏwy znŏk",
  "block.minecraft.spruce_sign": "smrekŏwy znŏk",
  "block.minecraft.birch_sign": "brzeźny znŏk",
  "block.minecraft.jungle_sign": "dżunglŏwy znŏk",
  "block.minecraft.acacia_sign": "agacŏwy znŏk",
  "block.minecraft.dark_oak_sign": "ćmawodymbŏwy znŏk",
  "block.minecraft.crimson_sign": "szkarłŏtny znŏk",
  "block.minecraft.warped_sign": "szagi znŏk",
  "item.minecraft.bucket": "kibel",
  "item.minecraft.water_bucket": "kibel ze wodōm",
  "item.minecraft.lava_bucket": "kibel ze lawōm",
  "item.minecraft.minecart": "wagōn",
  "item.minecraft.saddle": "zic",
  "item.minecraft.redstone": "utrzyty rudziŏk",
  "item.minecraft.snowball": "śniyżka",
  "item.minecraft.oak_boat": "dymbowy korab",
  "item.minecraft.leather": "skōra",
  "item.minecraft.milk_bucket": "kibel mlyka",
  "item.minecraft.pufferfish_bucket": "kibel ze balorybōm",
  "item.minecraft.salmon_bucket": "kibel ze łosōsiym",
  "item.minecraft.cod_bucket": "kibel ze wōntuszym",
  "item.minecraft.tropical_fish_bucket": "kibel ze dżunglowōm rybōm",
  "item.minecraft.brick": "cygłōwka",
  "item.minecraft.clay_ball": "bal bōncu",
  "block.minecraft.dried_kelp_block": "blok wyschnytych algōw",
  "item.minecraft.paper": "papjōr",
  "item.minecraft.book": "ksiōnżka",
  "item.minecraft.slime_ball": "szlōmkula",
  "item.minecraft.chest_minecart": "wagōn ze kastlōm",
  "item.minecraft.furnace_minecart": "damfmaszyna",
  "item.minecraft.egg": "jajco",
  "item.minecraft.compass": "kōmpas",
  "item.minecraft.fishing_rod": "wyndka",
  "item.minecraft.clock": "zygor",
  "item.minecraft.glowstone_dust": "proch ze blyndoka",
  "item.minecraft.cod": "surowy wōntusz",
  "item.minecraft.salmon": "surowy łosōś",
  "item.minecraft.tropical_fish": "dżunglowŏ ryba",
  "item.minecraft.pufferfish": "baloryba",
  "item.minecraft.cooked_cod": "pieczōny wōntusz",
  "item.minecraft.cooked_salmon": "pieczōny łosōś",
  "item.minecraft.ink_sac": "miech ze tintōm",
  "item.minecraft.red_dye": "czyrwōnŏ barwiczka",
  "item.minecraft.green_dye": "źielōnŏ barwiczka",
  "item.minecraft.cocoa_beans": "ôsucie kakaôwe",
  "item.minecraft.lapis_lazuli": "lazurit",
  "item.minecraft.purple_dye": "lilowŏ barwiczka",
  "item.minecraft.cyan_dye": "azurowŏ barwiczka",
  "item.minecraft.light_gray_dye": "jasnoszadŏ barwiczka",
  "item.minecraft.gray_dye": "szadŏ barwiczka",
  "item.minecraft.pink_dye": "rōżŏwŏ barwiczka",
  "item.minecraft.lime_dye": "limōnkowŏ barwiczka",
  "item.minecraft.yellow_dye": "żōłtŏ barwiczka",
  "item.minecraft.light_blue_dye": "jasnomodrŏ barwiczka",
  "item.minecraft.magenta_dye": "karminowŏ farbiczka",
  "item.minecraft.orange_dye": "oranżowŏ barwiczka",
  "item.minecraft.bone_meal": "kostyrnŏ mōnczkŏ",
  "item.minecraft.blue_dye": "mŏdrŏ barwiczka",
  "item.minecraft.brown_dye": "brunŏtnŏ barwiczka",
  "item.minecraft.black_dye": "czornŏ barwiczka",
  "item.minecraft.white_dye": "bjołŏ barwiczka",
  "item.minecraft.bone": "kostyra",
  "item.minecraft.sugar": "cuker",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "bjołe lyże",
  "block.minecraft.orange_bed": "oranżowe lyże",
  "block.minecraft.magenta_bed": "karminowe lyże",
  "block.minecraft.light_blue_bed": "jasnomodre lyże",
  "block.minecraft.yellow_bed": "żołte lyże",
  "block.minecraft.lime_bed": "limōnkowe lyże",
  "block.minecraft.pink_bed": "rōżowe lyże",
  "block.minecraft.gray_bed": "szade lyże",
  "block.minecraft.light_gray_bed": "jasnoszade lyże",
  "block.minecraft.cyan_bed": "azurowe lyże",
  "block.minecraft.purple_bed": "lilowe lyże",
  "block.minecraft.blue_bed": "modre lyże",
  "block.minecraft.brown_bed": "brunatne lyże",
  "block.minecraft.green_bed": "źielōne lyże",
  "block.minecraft.red_bed": "czerwōne lyże",
  "block.minecraft.black_bed": "czorne lyże",
  "item.minecraft.cookie": "kyjks",
  "item.minecraft.filled_map": "karta□#0",
  "item.minecraft.shears": "szery",
  "item.minecraft.melon_slice": "kōnsek arbuza",
  "item.minecraft.dried_kelp": "suszonŏ alga",
  "item.minecraft.pumpkin_seeds": "ôsucie bani",
  "item.minecraft.melon_seeds": "ôsucie arbuza",
  "item.minecraft.beef": "surowŏ ôwiyzna",
  "item.minecraft.cooked_beef": "stek",
  "item.minecraft.chicken": "surowy kurzik",
  "item.minecraft.cooked_chicken": "pieczōny kurzik",
  "item.minecraft.rotten_flesh": "zgyrōwane mjynsŏ",
  "item.minecraft.ender_pearl": "endowŏ byrka",
  "item.minecraft.blaze_rod": "flamŏkowy prōntek",
  "item.minecraft.ghast_tear": "płaczka ghasta",
  "item.minecraft.gold_nugget": "kōnsek zôta",
  "item.minecraft.nether_wart": "netherowŏ chrosta",
  "item.minecraft.potion": "ńyzłōnaczalny wywōr□żŏdnych efyktōw",
  "item.minecraft.glass_bottle": "flaszka",
  "item.minecraft.spider_eye": "ślypie pajōnka",
  "item.minecraft.fermented_spider_eye": "zgyrōwane ślypie pajōnka",
  "item.minecraft.blaze_powder": "flamŏkowy pulwer",
  "item.minecraft.magma_cream": "magmōwy krym",
  "block.minecraft.brewing_stand": "sztynder do warzyniŏ",
  "block.minecraft.cauldron": "kastrol",
  "item.minecraft.ender_eye": "ślypie endu",
  "item.minecraft.glistering_melon_slice": "zôtawy kōnsek arbuza",
  "item.minecraft.bat_spawn_egg": "jajco ze gacopjyrzym",
  "item.minecraft.bee_spawn_egg": "jajco ze binōm",
  "item.minecraft.blaze_spawn_egg": "jajco ze flamŏkiym",
  "item.minecraft.cat_spawn_egg": "jajco ze kotym",
  "item.minecraft.cave_spider_spawn_egg": "jajco ze jaskińōwym pajōnkiym",
  "item.minecraft.chicken_spawn_egg": "jajco ze kurzikiym",
  "item.minecraft.cod_spawn_egg": "jajco ze wōntuszym",
  "item.minecraft.cow_spawn_egg": "jajco ze kalymbōm",
  "item.minecraft.creeper_spawn_egg": "jajco ze creeperem",
  "item.minecraft.dolphin_spawn_egg": "jajco ze dylfinym",
  "item.minecraft.donkey_spawn_egg": "jajco ze ôsłym",
  "item.minecraft.drowned_spawn_egg": "jajco ze utopkiym",
  "item.minecraft.elder_guardian_spawn_egg": "jajco ze chańdownym wachtyrzym",
  "item.minecraft.enderman_spawn_egg": "jajco ze endermonym",
  "item.minecraft.endermite_spawn_egg": "jajco ze endermitym",
  "item.minecraft.evoker_spawn_egg": "jajco ze guślŏrzym",
  "item.minecraft.fox_spawn_egg": "jajco z liszkōm",
  "item.minecraft.ghast_spawn_egg": "jajco ze dōchym",
  "item.minecraft.guardian_spawn_egg": "jajco ze wachtyrzym",
  "item.minecraft.hoglin_spawn_egg": "jajco ze hoglinym",
  "item.minecraft.horse_spawn_egg": "jajco ze kōniym",
  "item.minecraft.husk_spawn_egg": "jajco ze zdechlŏkiym",
  "item.minecraft.llama_spawn_egg": "jajco ze lamōm",
  "item.minecraft.magma_cube_spawn_egg": "jajco ze magmŏkiym",
  "item.minecraft.mooshroom_spawn_egg": "jajco ze mooshroomym",
  "item.minecraft.mule_spawn_egg": "jajco ze mōłym",
  "item.minecraft.ocelot_spawn_egg": "jajco ze ôcylotym",
  "item.minecraft.panda_spawn_egg": "jajco ze pandōm",
  "item.minecraft.parrot_spawn_egg": "jajco ze papagajym",
  "item.minecraft.phantom_spawn_egg": "jajco ze fantōmym",
  "item.minecraft.pig_spawn_egg": "jajco ze świniokiym",
  "item.minecraft.piglin_spawn_egg": "jajco ze piglinym",
  "item.minecraft.pillager_spawn_egg": "jajco ze rōmplym",
  "item.minecraft.polar_bear_spawn_egg": "jajco ze śniygŏwym ńydźwjydźym",
  "item.minecraft.pufferfish_spawn_egg": "jajco ze balorybōm",
  "item.minecraft.rabbit_spawn_egg": "jajco ze mycŏkiym",
  "item.minecraft.ravager_spawn_egg": "jajco ze poprzniyciylym",
  "item.minecraft.salmon_spawn_egg": "jajco ze łosōsiym",
  "item.minecraft.sheep_spawn_egg": "jajco ze ôwcōm",
  "item.minecraft.shulker_spawn_egg": "jajco ze shulkerym",
  "item.minecraft.silverfish_spawn_egg": "jajco ze strzibnorybōm",
  "item.minecraft.skeleton_spawn_egg": "jajco ze szkeletym",
  "item.minecraft.skeleton_horse_spawn_egg": "jajco ze kōniym szkeletym",
  "item.minecraft.slime_spawn_egg": "jajco ze szlamym",
  "item.minecraft.spider_spawn_egg": "jajco ze pajōnkiym",
  "item.minecraft.squid_spawn_egg": "jajco ze kalmŏrzym",
  "item.minecraft.stray_spawn_egg": "jajco ze łazyngōm",
  "item.minecraft.strider_spawn_egg": "jajco ze magmŏkiym",
  "item.minecraft.trader_llama_spawn_egg": "jajco z lamōm handlyrza",
  "item.minecraft.tropical_fish_spawn_egg": "jajco ze dżunglowōm rybōm",
  "item.minecraft.turtle_spawn_egg": "jajco ze żōłwiym",
  "item.minecraft.vex_spawn_egg": "jajco ze żgŏczym",
  "item.minecraft.villager_spawn_egg": "jajco ze siedlŏkiym",
  "item.minecraft.vindicator_spawn_egg": "jajco ze zymściciylym",
  "item.minecraft.wandering_trader_spawn_egg": "jajco z wandrownym handlyrzym",
  "item.minecraft.witch_spawn_egg": "jajco ze heksōm",
  "item.minecraft.wither_skeleton_spawn_egg": "jajco ze witherowym szkeletym",
  "item.minecraft.wolf_spawn_egg": "jajco ze wilkiym",
  "item.minecraft.zoglin_spawn_egg": "jajco ze zoglinym",
  "item.minecraft.zombie_spawn_egg": "jajco ze zōmbiokiym",
  "item.minecraft.zombie_horse_spawn_egg": "jajco ze kōniym zōmbiokiym",
  "item.minecraft.zombie_villager_spawn_egg": "jajco ze siedlŏkiym-zōmbiŏkiym",
  "item.minecraft.zombified_piglin_spawn_egg": "jajco ze piglinym-zōmbiŏkiym",
  "item.minecraft.experience_bottle": "zamagōwanŏ flaszka",
  "item.minecraft.fire_charge": "ôgnisty bal",
  "item.minecraft.writable_book": "ksiōnżka ze filokem",
  "item.minecraft.written_book": "szrajbnytŏ ksiōnżka",
  "item.minecraft.emerald": "szmarogd",
  "item.minecraft.item_frame": "roma na klamoty",
  "block.minecraft.flower_pot": "dōniczka",
  "item.minecraft.carrot": "markew",
  "item.minecraft.potato": "kartofel",
  "item.minecraft.baked_potato": "pieczōny kartofel",
  "item.minecraft.poisonous_potato": "potruty kartofel",
  "item.minecraft.map": "prōżnŏ karta",
  "item.minecraft.golden_carrot": "zôtŏ markew",
  "block.minecraft.skeleton_skull": "czacha szkeleta",
  "block.minecraft.wither_skeleton_skull": "czacha witherowygŏ szkeleta",
  "block.minecraft.player_head": "gowa grŏcza",
  "block.minecraft.zombie_head": "gowa zōmbiaka",
  "block.minecraft.creeper_head": "gowa creepera",
  "block.minecraft.dragon_head": "gowa draka",
  "item.minecraft.carrot_on_a_stick": "markew na kijoku",
  "item.minecraft.warped_fungus_on_a_stick": "szagi grzib na kijŏku",
  "item.minecraft.nether_star": "netherowŏ gwjŏzdŏ",
  "item.minecraft.pumpkin_pie": "kołŏcz ze bani",
  "item.minecraft.firework_rocket": "fojerwerka",
  "item.minecraft.firework_star": "fojerwekowŏ gwiŏzdka",
  "item.minecraft.enchanted_book": "zamagōwanŏ ksiōnżka",
  "item.minecraft.nether_brick": "netherowe cygłōwki",
  "item.minecraft.quartz": "kworc",
  "item.minecraft.tnt_minecart": "wagōn ze tnt",
  "item.minecraft.hopper_minecart": "wagōn ze lyjokiym",
  "item.minecraft.prismarine_shard": "szkyrtek prizmarinu",
  "item.minecraft.prismarine_crystals": "krysztoły prizmarinu",
  "item.minecraft.rabbit": "surowy mycŏk",
  "item.minecraft.cooked_rabbit": "pieczōny mycŏk",
  "item.minecraft.rabbit_stew": "ańtop ze mycŏka",
  "item.minecraft.rabbit_foot": "szłapka mycŏka",
  "item.minecraft.rabbit_hide": "skora mycŏka",
  "item.minecraft.armor_stand": "stojŏk na zbrojŏ",
  "item.minecraft.iron_horse_armor": "żylŏznŏ kōńskŏ zbrojŏ",
  "item.minecraft.golden_horse_armor": "zôtŏ kōńskŏ zbrojŏ",
  "item.minecraft.diamond_horse_armor": "dyjomyntowŏ kōńskŏ zbrojŏ",
  "item.minecraft.leather_horse_armor": "skōrzannŏ kōńskŏ zbroja",
  "item.minecraft.lead": "smycz",
  "item.minecraft.name_tag": "znocznik",
  "item.minecraft.command_block_minecart": "wagōn ze blokiym kōmynd",
  "item.minecraft.mutton": "surowŏ szkopina",
  "item.minecraft.cooked_mutton": "pieczōnŏ szkopina",
  "block.minecraft.white_banner": "bjołŏ fana",
  "block.minecraft.orange_banner": "oranżowŏ fana",
  "block.minecraft.magenta_banner": "karminowŏ fana",
  "block.minecraft.light_blue_banner": "jasnomodrŏ fana",
  "block.minecraft.yellow_banner": "żōłtŏ fana",
  "block.minecraft.lime_banner": "limōnkowŏ fana",
  "block.minecraft.pink_banner": "rōżŏwŏ fana",
  "block.minecraft.gray_banner": "szadŏ fana",
  "block.minecraft.light_gray_banner": "jasnoszadŏ fana",
  "block.minecraft.cyan_banner": "azurowŏ fana",
  "block.minecraft.purple_banner": "lilowŏ fana",
  "block.minecraft.blue_banner": "modrŏ fana",
  "block.minecraft.brown_banner": "brunatnŏ fana",
  "block.minecraft.green_banner": "zielōnŏ fana",
  "block.minecraft.red_banner": "czerwōnŏ fana",
  "block.minecraft.black_banner": "czornŏ fana",
  "item.minecraft.end_crystal": "krysztoł endu",
  "item.minecraft.chorus_fruit": "ôwŏc refrynki",
  "item.minecraft.popped_chorus_fruit": "pieczka refrynki",
  "item.minecraft.beetroot": "ćwikla",
  "item.minecraft.beetroot_seeds": "ôsucie ćwikly",
  "item.minecraft.beetroot_soup": "ćwikelzupa",
  "item.minecraft.dragon_breath": "dech draka",
  "item.minecraft.splash_potion": "ciepany ńyzłōnaczalny wywōr□żŏdnych efyktōw",
  "item.minecraft.spectral_arrow": "blinkowŏ strzała",
  "item.minecraft.tipped_arrow": "ńyzłōnaczalnŏ tōnknytŏ strzała□żŏdnych efyktōw",
  "item.minecraft.lingering_potion": "ńyzłōnaczalny kurzwywōr□żŏdnych efyktōw",
  "item.minecraft.shield": "powynż",
  "item.minecraft.elytra": "krzidła",
  "item.minecraft.spruce_boat": "smrekowy korab",
  "item.minecraft.birch_boat": "brzeźny korab",
  "item.minecraft.jungle_boat": "dżunglowy korab",
  "item.minecraft.acacia_boat": "agacowy korab",
  "item.minecraft.dark_oak_boat": "ćmawodymbowy korab",
  "item.minecraft.totem_of_undying": "totym niyśmiyrtelności",
  "item.minecraft.shulker_shell": "szupa shulkera",
  "item.minecraft.iron_nugget": "kōnsek żylŏzŏ",
  "item.minecraft.knowledge_book": "yncyklopedyjŏ",
  "item.minecraft.debug_stick": "kobyr dŏ ôdłōnaczaniŏ",
  "item.minecraft.music_disc_13": "dysketka□c418 - 13",
  "item.minecraft.music_disc_cat": "dysketka□c418 - cat",
  "item.minecraft.music_disc_blocks": "dysketka□c418 - blocks",
  "item.minecraft.music_disc_chirp": "dysketka□c418 - chirp",
  "item.minecraft.music_disc_far": "dysketka□c418 - far",
  "item.minecraft.music_disc_mall": "dysketka□c418 - mall",
  "item.minecraft.music_disc_mellohi": "dysketka□c418 - mellohi",
  "item.minecraft.music_disc_stal": "dysketka□c418 - stal",
  "item.minecraft.music_disc_strad": "dysketka□c418 - strad",
  "item.minecraft.music_disc_ward": "dysketka□c418 - ward",
  "item.minecraft.music_disc_11": "dysketka□c418 - 11",
  "item.minecraft.music_disc_wait": "dysketka□c418 - wait",
  "item.minecraft.music_disc_pigstep": "dysketka□lena raine – pigstep",
  "item.minecraft.trident": "trzizōmb□□kiej we gōwnyj rynce:□+8 ôchybiyniŏ□-2.9 gibkość napŏdu",
  "item.minecraft.phantom_membrane": "błōna fantōma",
  "item.minecraft.nautilus_shell": "szupa łodzika",
  "item.minecraft.heart_of_the_sea": "syrce ôcyjonu",
  "item.minecraft.crossbow": "kusza",
  "item.minecraft.suspicious_stew": "podyjzdrzany ańtop",
  "block.minecraft.loom": "sztrekmaszina",
  "item.minecraft.flower_banner_pattern": "wzōr fany□kwiŏtek",
  "item.minecraft.creeper_banner_pattern": "wzōr fany□gowa creepera",
  "item.minecraft.skull_banner_pattern": "wzōr fany□czacha",
  "item.minecraft.mojang_banner_pattern": "wzōr fany□cosi",
  "item.minecraft.globe_banner_pattern": "wzōr fany□ziymiokostka",
  "item.minecraft.piglin_banner_pattern": "wzōr fany□sznupa",
  "block.minecraft.composter": "hasiok",
  "block.minecraft.barrel": "faska",
  "block.minecraft.smoker": "wyndzŏk",
  "block.minecraft.blast_furnace": "martin",
  "block.minecraft.cartography_table": "kartografowy stōł",
  "block.minecraft.fletching_table": "stōł dŏ strzał",
  "block.minecraft.grindstone": "brusek",
  "block.minecraft.lectern": "sztynder",
  "block.minecraft.smithing_table": "kŏwŏczowy stōł",
  "block.minecraft.stonecutter": "krajzyga",
  "block.minecraft.bell": "zwōn",
  "block.minecraft.lantern": "blyndka",
  "block.minecraft.soul_lantern": "blyndka dusz",
  "item.minecraft.sweet_berries": "słodke borōwki",
  "block.minecraft.campfire": "fojera",
  "block.minecraft.soul_campfire": "fojera dusz",
  "block.minecraft.shroomlight": "blyndogrzib",
  "item.minecraft.honeycomb": "miodny ślyzyk",
  "block.minecraft.bee_nest": "gniŏzdo binōw",
  "block.minecraft.beehive": "binehaus",
  "item.minecraft.honey_bottle": "flaszka miodu",
  "block.minecraft.honey_block": "blok miodu",
  "block.minecraft.honeycomb_block": "blok ślyzykōw miodu",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "blok netheritu",
  "block.minecraft.ancient_debris": "dŏwny ściep",
  "block.minecraft.target": "tarcza",
  "block.minecraft.crying_obsidian": "płaczkowy ôbsydjōn",
  "block.minecraft.blackstone": "czorniŏk",
  "block.minecraft.blackstone_slab": "czorniŏkowŏ kachla",
  "block.minecraft.blackstone_stairs": "czorniŏkowe schodki",
  "block.minecraft.gilded_blackstone": "zôcōny czorniŏk",
  "block.minecraft.polished_blackstone": "wyglancōwany czorniŏk",
  "block.minecraft.polished_blackstone_slab": "wyglancōwanŏ czorniŏkowŏ kachla",
  "block.minecraft.polished_blackstone_stairs": "wyglancōwane czorniŏkowe schodki",
  "block.minecraft.chiseled_polished_blackstone": "ôciosany wyglancōwany czorniŏk",
  "block.minecraft.polished_blackstone_bricks": "wyglancōwane czorniŏkowe cygłōwki",
  "block.minecraft.polished_blackstone_brick_slab": "wyglancōwanŏ czorniŏkowŏ cyglōwkowŏ kachla",
  "block.minecraft.polished_blackstone_brick_stairs": "wyglancōwane czorniŏkowe cygłōwkowe schodki",
  "block.minecraft.cracked_polished_blackstone_bricks": "pynknyte wyglancōwane czorniŏkowe cygłōwki",
  "block.minecraft.respawn_anchor": "ankra ôdrŏdzyniŏ",
}
export const szl = items; 
